import { BR_STATUS, getBrSubmissionApprovalId } from '../utils/brDocument';
import { getApprovedBrForNameChangeOptions } from '../utils/brNameChange';

/** 更名弹窗状态与提交流程（供应商 / 管理端共用）。页面覆盖 getNameChangeDocumentList 等钩子。 */
export default {
  data() {
    return {
      showNameChangeModal: false,
      nameChangeSourceApprovalId: null,
      showNameChangeSuccess: false,
      /** 接口返回 StatusCode=A（管理员一遍过）时用独立成功文案 */
      nameChangeSuccessIsAutoApproved: false,
    };
  },
  computed: {
    nameChangeSuccessTitle() {
      return this.nameChangeSuccessIsAutoApproved
        ? this.$t('lbl_EMPBE_BR_NameChange_AdminSuccessTitle')
        : this.$t('lbl_EMPBE_BR_NameChange_SuccessTitle');
    },
    nameChangeSuccessBody() {
      return this.nameChangeSuccessIsAutoApproved
        ? this.$t('lbl_EMPBE_BR_NameChange_AdminSuccessBody')
        : this.$t('lbl_EMPBE_BR_NameChange_SuccessBody');
    },
  },
  methods: {
    getNameChangeDocumentList() {
      return [];
    },
    canOpenNameChange() {
      return getApprovedBrForNameChangeOptions(this.getNameChangeDocumentList()).length > 0;
    },
    onNameChangeCannotOpen() {},
    async afterNameChangeSubmitted() {},
    openNameChangeModal(item) {
      const options = getApprovedBrForNameChangeOptions(this.getNameChangeDocumentList());
      if (!options.length) {
        this.onNameChangeCannotOpen();
        return;
      }
      const fromItem = Number(getBrSubmissionApprovalId(item));
      this.nameChangeSourceApprovalId = (Number.isFinite(fromItem) && fromItem > 0)
        ? fromItem
        : (getBrSubmissionApprovalId(options[0]) || null);
      this.showNameChangeModal = true;
    },
    closeNameChangeModal() {
      this.showNameChangeModal = false;
      this.nameChangeSourceApprovalId = null;
    },
    closeNameChangeSuccess() {
      this.showNameChangeSuccess = false;
      this.nameChangeSuccessIsAutoApproved = false;
    },
    async handleNameChangeSubmitted(payload) {
      const statusCode = String(
        payload?.statusCode ?? payload?.StatusCode ?? '',
      ).toUpperCase();
      // 管理员 submitType=edit → SP 直接 A；供应商恒为 PA
      this.nameChangeSuccessIsAutoApproved = statusCode === BR_STATUS.APPROVED;
      this.closeNameChangeModal();
      await this.afterNameChangeSubmitted(payload);
      this.showNameChangeSuccess = true;
    },
  },
};
